import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Box, Select,
  FormControl, InputLabel,MenuItem,Menu,ListItemIcon,ListItemText,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from "../../../../AuthProvider";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { useLocation } from "react-router-dom";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
function PresentBusAttendeesList() {
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  
  
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const navigate = useNavigate();

  const [selectedBus, setSelectedBus] = useState("");
  const {oId,role,board,userId,pId }=useAuth();
  const [busData, setBusData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  const { state } = useLocation();
    const principalId = state?.PrincipalId;
    const PrincipalId = pId || principalId;



  // const [sscSelectedClass, setSscSelectedClass] = useState("Class-I");
  // const [sscSelectedSection, setSscSelectedSection] = useState("Section-A");
  
  // // INTERMEDIATE states

  // const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  // const [interSelectedSection, setInterSelectedSection] = useState("Section-A");

  //  const [tableLoading, setTableLoading] = useState(true);
  //SSC states
    const [sscClassOptions, setSscClassOptions] = useState([]);
    const [sscSectionOptions, setSscSectionOptions] = useState([]);
    const [sscSelectedClass, setSscSelectedClass] = useState("");
    // const [sscSelectedSection, setSscSelectedSection] = useState("");
    const [sscSelectedSection, setSscSelectedSection] = useState("");
  
    // INTERMEDIATE states
    const [interSectionOptions, setInterSectionOptions] = useState([]);
    // const [interSelectedClass, setInterSelectedClass] = useState("");
    // const [interSelectedSection, setInterSelectedSection] = useState('');
    const [interSelectedClass, setInterSelectedClass] = useState("");
    const [interSelectedSection, setInterSelectedSection] = useState("");
    const [courseOptions, setCourseOptions] = useState([]);
    const [selectedCourseType, setSelectedCourseType] = useState("");
  
    const [romanNumberClass, setRomanNumberClass] = useState("");
     const [dialogcourse, setDialogCourse] = useState("");
  
    const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
    console.log("selected mode :"+mode);
    const [sscClassSectionMap, setSscClassSectionMap] = useState({});
    const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag
  
 


  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setFilteredData(sampleData);
  //     setLoading(false);
  //   }, 1000);
  // }, []);

  // useEffect(() => {
  //   const result = filteredData.filter((row) => {
  //     const name = row.name ? row.name.toLowerCase() : "";
  //     const id = row.id ? row.id.toString() : "";
  //     return name.includes(searchQuery.toLowerCase()) || id.includes(searchQuery);
  //   });
  //   setFilteredData(result);
  // }, [searchQuery]);


   // Filter data based on searchQuery
   const filteredResults = filteredData.filter((item) => {
    const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
    const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
    const fullName = `${studentFirstName} ${studentLastName}`.trim(); // Combine first and last names
    const admissionNumber = item.generatedAdmissionNumber ? item.generatedAdmissionNumber.toString() : ""; // Ensure it's a string
  
    return (
      fullName.includes(searchQuery.toLowerCase()) || // Search in full name
      admissionNumber.includes(searchQuery) // Search in admission number
    );
  });


  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  const handleSaveChanges = () => {
    setFilteredData((prevData) =>
      prevData.map((row) =>
        row.id === selectedRow.id ? selectedRow : row
      )
    );
    handleDialogClose(); // Close the dialog
  };

  const [users, setUsers] = useState([]);
      const [selectedUsers, setSelectedUsers] = useState('');
      const isPrincipal = role?.startsWith("PRINCIPAL") || false;
      const UserId = userId || selectedUsers;
      
    
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch users');
                }
                const data = await response.json();
                setUsers(data);
                if (data.length > 0) {
                  setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
              }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
       useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);


  //select Bus API
  console.log("Filtered Data:", filteredResults);
    useEffect(() => {
      const fetchData = async () => {
        if(!UserId) return;
        try {
          const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${oId}/${UserId}`);
          if (!response.ok) throw new Error("Failed to fetch bus numbers");
    
          const data = await response.json();
          console.log("Fetched Bus Numbers:", data);
          setBusData(data || []); 
    
          if (data.length > 0) {
            setSelectedBus(data[0]); // Default to first bus number
             setSscSelectedClass("");
          }
        } catch (error) {
          console.error("Error fetching bus numbers:", error);
        }
      };
    
      fetchData();
    }, [oId,UserId]); 


  //List Api
  const fetchBusFeeDetails = async () => {
    if (!selectedBus) {
      setTableLoading(false); // Ensure loading state is removed if no bus is selected
      return; 
    }
      setTableLoading(true); // Set loading to true before fetching data
    
      try {
        const response = await fetch(
          `${baseUrl}/api/busAttendiesDashBoard/getAllStudentsPresentInBus/${oId}?busNumber=${selectedBus.busNumber}&rolePayment=bus_attendees`
        );
    
        if (!response.ok) throw new Error("Failed to fetch transactions");
    
        const data = await response.json();
        console.log("Bus Fee Data:", data);
    
        setFilteredData(data || []);
      } catch (err) {
        console.error("Error fetching transactions:", err);
        // setFilteredData([]); // Ensure table does not break on error
      } finally {
        setTableLoading(false); // Set loading to false after fetching (whether success or error)
      }
    };
    
    useEffect(() => {
      fetchBusFeeDetails();
    }, [selectedBus, oId]); 


    // -------------------------------------------
      //           For SSC functions
      // -------------------------------------------
      
      // ---- Fetch Class + Sections for SSC (School) ----
      const fetchClassRegistrationData = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${PrincipalId}`);
          const data = await response.json();
      
          if (response.ok && Array.isArray(data)) {
            // Group by class and merge section strings into unique values
            const classSectionMap = {};
      
            data.forEach(item => {
              const className = item.classRegistration;
              const sectionList = item.sections.split(",").map(s => s.trim());
      
              if (!classSectionMap[className]) {
                classSectionMap[className] = new Set();
              }
      
              sectionList.forEach(section => classSectionMap[className].add(section));
            });
      
            const classes = Object.keys(classSectionMap);
            setSscClassOptions(classes); // Class dropdown options
            setSscClassSectionMap(classSectionMap); // Save for section filtering later
      
            // No default selection
            setSscSelectedClass("");
            setSscSelectedSection("");
            setSscSectionOptions([]);
          }
        } catch (error) {
          console.error("Error fetching SSC data:", error);
        }
      };
      
      
      
       //fetch students data with bus filter with class, section
      
      // ---- Fetch Table Data for SSC ----
      const fetchClassSectionTableData = async () => {
        if (!sscSelectedClass || !sscSelectedSection) {
          setFilteredData([]);
          // setOriginalData([]);
          setTableLoading(false);
          return;
        }
        setTableLoading(true);
        try {
          const response = await fetch(
            `${baseUrl}/api/busAttendiesDashBoard/getAllStudentsPresentInBusClassAndSectionWise/${pId}/${oId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
          );
          const data = await response.json();
          if (response.ok) {
            // setOriginalData(data);
            setFilteredData(data || []);
            // setFilteredData(data.feePayments || []);
            // setUniqueCourseType([...new Set(data.map(item => item.course))]);
          } else {
            // setOriginalData([]);
            setFilteredData([]);
          }
        } catch (error) {
          console.error("Error fetching SSC table data:", error);
        } finally {
          setTableLoading(false);
        }
      };
      
      
      
      
      // -------------------------------------------
      //           For Intermediate functions
      // -------------------------------------------
      
      // ---- Fetch Courses for INTERMEDIATE ----
      const fetchCourseData = async () => {
        if(!interSelectedClass) return;
        try {
          const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${PrincipalId}?romanNumberClass=${interSelectedClass}`);
          const data = await response.json();
          if (response.ok && Array.isArray(data)) {
            setCourseOptions(data);
            // if (!selectedCourseType) {
            //   setSelectedCourseType("");
            // }
          } else {
            setCourseOptions([]);
          }
        } catch (error) {
          console.error("Error fetching course data:", error);
          setCourseOptions([]);
        }
      };
      
      // ---- Fetch Sections for INTERMEDIATE ----
      
      const fetchSectionsData = async () => {
        if (!interSelectedClass || !selectedCourseType) {
          setInterSectionOptions([]);
          setInterSelectedSection("");
          return;
        }
      
        try {
          const response = await fetch(
            `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${PrincipalId}`
          );
          const data = await response.json();
      
          if (response.ok && Array.isArray(data) && data.length > 0) {
            const sectionsString = data[0].sections || "";
            const sections = sectionsString
              .split(",")
              .map((section) => section.trim());
      
            setInterSectionOptions(sections);
            setInterSelectedSection(sections[0] || "");
          } else {
            setInterSectionOptions([]);
            setInterSelectedSection("");
          }
        } catch (error) {
          console.error("Error fetching INTERMEDIATE section data:", error);
          setInterSectionOptions([]);
          setInterSelectedSection("");
        }
      };
      
      
      
      
      
      
      // ---- Fetch Table Data for INTERMEDIATE ----
      const fetchCourseClassSectionTableData = async () => {
        if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
          setFilteredData([]);
          // setOriginalData([]);
          setTableLoading(false);
          return;
        }
        setTableLoading(true);
        try {
          const response = await fetch(
            `${baseUrl}/api/feePayment/adm/getAllfeePayments/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&rolePayment=tution_fee`
            
          );
          const data = await response.json();
          if (response.ok) {
            // setOriginalData(data);
            setFilteredData(data.feePayments || []);
            // setUniqueCourseType([...new Set(data.map(item => item.course))]);
          } else {
            // setOriginalData([]);
            setFilteredData([]);
          }
        } catch (error) {
          console.error("Error fetching INTERMEDIATE table data:", error);
          setFilteredData([]);
        } finally {
          setTableLoading(false);
        }
      };
      
      
      
      
      useEffect(() => {
        if (board === "INTERMEDIATE") {
          fetchSectionsData();
        } else if (board === "SSC") {
          fetchClassRegistrationData();
        }
      }, [board, interSelectedClass, selectedCourseType, oId]);
      
      // SSC: When selected class changes, update its sections
      // useEffect(() => {
      //   const updateSectionOptions = async () => {
      //     try {
      //       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
      //       const data = await response.json();
      //       if (response.ok && Array.isArray(data)) {
      //         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
      //         if (selectedClassData) {
      //           const sections = selectedClassData.sections.split(",");
      //           setSscSectionOptions(sections);
      //           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
      //         } else {
      //           setSscSectionOptions([]);
      //           setSscSelectedSection("");
      //         }
      //       }
      //     } catch (error) {
      //       console.error("Error updating SSC sections:", error);
      //     }
      //   };
      
      //   if (board === "SSC" && sscSelectedClass) {
      //     updateSectionOptions();
      //   }
      // }, [sscSelectedClass, board, oId]);
      
      // INTERMEDIATE: When class or course type changes, update sections
      useEffect(() => {
        const updateIntermediateSections = async () => {
          if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
            await fetchSectionsData();
          }
        };
        updateIntermediateSections();
      }, [interSelectedClass, selectedCourseType, board]);
      
      
      
      // Fetch course options if board is INTERMEDIATE
      useEffect(() => {
        if (board === "INTERMEDIATE") {
          fetchCourseData();
        }
      }, [interSelectedClass,board, oId]);
      
      // Fetch Table Data whenever filters change
      // useEffect(() => {
      //   if (board === "SSC") {
      //     if (!sscSelectedClass || !sscSelectedSection) {
      //       setFilteredData([]);
      //       setTableLoading(false); // ✅ stop loading even if API not called
      //       return;
      //     }
      //     fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
      //   } else if (board === "INTERMEDIATE") {
      //     if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
      //       setFilteredData([]);
      //       setTableLoading(false); // ✅ same here
      //       return;
      //     }
      //     fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
      //   }
      // }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);
      
      useEffect(() => {
        const fetchData = () => {
          if (board === "SSC") {
            if (sscSelectedClass && sscSelectedSection && mode === "classSection") {
              fetchClassSectionTableData();
            } else {
              setFilteredData([]);
              setTableLoading(false);
            }
          } else if (board === "INTERMEDIATE") {
            if (selectedCourseType && interSelectedClass && interSelectedSection && mode === "classSection") {
              fetchCourseClassSectionTableData();
            } else {
              setFilteredData([]);
              setTableLoading(false);
            }
          }
        };
      
        fetchData();
      }, [board, sscSelectedClass, sscSelectedSection, selectedCourseType, interSelectedClass, interSelectedSection, mode]);
      


  // Export to Excel
   const sanitizeName = (name) => name.replace(/[\\/*?:[\]]/g, "_"); // replace invalid chars with "_"

const exportToExcel = () => {
  const processedData = filteredResults.map(
    ({
      studentId,
      romanNumberClass,
      sections,
      course,
      studentFirstName,
      studentLastName,
      gender,
      busNumber,
      busNumberPlate,
      studentPickupLocation,
      studentDropLocation,
      fatherPhoneNumber,
    }) => ({
      StudentId: studentId,
      Course: course,
      Class: romanNumberClass,
      Section: sections,
      StudentName: `${studentFirstName} ${studentLastName}`,
      Gender: gender || "N/A",
      BusNumber: busNumberPlate,
      PickupLocation: studentPickupLocation,
      DropLocation: studentDropLocation,
      Phone: fatherPhoneNumber,
    })
  );

  const workbook = new ExcelJS.Workbook();

  // ✅ pick busNumberPlate (or busNumber) from selectedBus
  const busName = sanitizeName(selectedBus?.busNumberPlate || selectedBus?.busNumber || "Bus");

  const worksheet = workbook.addWorksheet(
    (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
      ? sanitizeName(`${interSelectedClass}-${interSelectedSection}_PresentBusAttendance_List`)
      : (board === "SSC" && sscSelectedClass && sscSelectedSection)
        ? sanitizeName(`${sscSelectedClass}-${sscSelectedSection}_PresentBusAttendance_List`)
        : sanitizeName(`${busName}_PresentBusAttendance_List`)
  );

  worksheet.columns = [
    { header: "Student Id", key: "StudentId", width: 15 },
    ...(board === "INTERMEDIATE"
      ? [{ header: "Course", key: "Course", width: 15 }]
      : []),
    { header: board === "INTERMEDIATE" ? "Year" : "Class", key: "Class", width: 15 },
    { header: "Section", key: "Section", width: 15 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Bus No", key: "BusNumber", width: 25 },
    { header: "Pickup Location", key: "PickupLocation", width: 20 },
    { header: "Drop Location", key: "DropLocation", width: 20 },
    { header: "Phone", key: "Phone", width: 15 },
  ];

  worksheet.addRows(processedData);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" },
    };
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);

    // ✅ also fix download filename
    link.download =
      (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection)
        ? sanitizeName(`${interSelectedClass}-${interSelectedSection}_PresentBusAttendance_List.xlsx`)
        : (board === "SSC" && sscSelectedClass && sscSelectedSection)
          ? sanitizeName(`${sscSelectedClass}-${sscSelectedSection}_PresentBusAttendance_List.xlsx`)
          : sanitizeName(`${busName}_PresentBusAttendance_List.xlsx`);

    link.click();
  });

  handleExportClose();
};

    // Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  const sanitizeName = (name) => name?.toString().replace(/[\\/*?:[\]<>|]/g, "_") || "Bus";

  // ✅ pick busName properly
  const busName = sanitizeName(selectedBus?.busNumberPlate || selectedBus?.busNumber);

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");

  if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
    doc.text(`${interSelectedClass}-${interSelectedSection} Present Bus Attendance List`, 10, 8);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.text(`${sscSelectedClass}-${sscSelectedSection} Present Bus Attendance List`, 10, 8);
  } else {
    doc.text(`${busName} - Present Bus Attendance List`, 10, 8);
  }

  // Subtitle
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Table headers
  const headers = board === "INTERMEDIATE"
    ? [
        "S.No",
        "Course",
        "Year",
        "Section",
        "Student Name",
        "Gender",
        "Bus No",
        "Pickup Location",
        "Drop Location",
        "Phone",
      ]
    : [
        "S.No",
        "Class",
        "Section",
        "Student Name",
        "Gender",
        "Bus No",
        "Pickup Location",
        "Drop Location",
        "Phone",
      ];

  // Table body
  const body = filteredResults.map((row, index) => {
    const rowData = [index + 1];

    if (board === "INTERMEDIATE") {
      rowData.push(row.course);
    }

    rowData.push(
      `${row.romanNumberClass}`,
      row.sections,
      `${row.studentFirstName} ${row.studentLastName}`,
      row.gender || "N/A",
      row.busNumberPlate,
      row.studentPickupLocation,
      row.studentDropLocation,
      row.fatherPhoneNumber
    );

    return rowData;
  });

  // Table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body: body,
    margin: { top: 0, left: 3, right: 3 },
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // ✅ Save PDF with clean dynamic filename
  if (board === "INTERMEDIATE" && interSelectedClass && interSelectedSection) {
    doc.save(`${sanitizeName(`${interSelectedClass}-${interSelectedSection}`)}_PresentBusAttendance_List.pdf`);
  } else if (board === "SSC" && sscSelectedClass && sscSelectedSection) {
    doc.save(`${sanitizeName(`${sscSelectedClass}-${sscSelectedSection}`)}_PresentBusAttendance_List.pdf`);
  } else {
    doc.save(`${busName}_PresentBusAttendance_List.pdf`);
  }

  handleExportClose();
};

    // Export to JSON
    const exportToJSON = () => {
      const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
        JSON.stringify(filteredResults, null, 2)
      )}`;
      const link = document.createElement("a");
      link.href = jsonString;
      link.download = "PresentBusAttendanceList.json";
      link.click();
      handleExportClose();
    };

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
     
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate('/TransportDashboard')} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Present Bus Attendance
                              </Typography>
                            </Box>

        {/* Search and Add New Button Section */}
<Grid
  container
  spacing={2}
  alignItems="center"
  wrap="nowrap"
  style={{ marginTop: "1px", overflowX: "auto" }}
>
  {/* Filters Section */}
  <Grid item xs style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "nowrap" }}>
    <TextField
      label="Search by Name"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      style={{ width: "200px" }}
    />

    <FormControl style={{ width: "180px" }} variant="outlined" size="small">
  <InputLabel id="bus-select-label">Select Bus</InputLabel>
  <Select
    labelId="bus-select-label"
    value={selectedBus}
    onChange={(e) => {
      setSelectedBus(e.target.value); // will store the full bus object
      setSscSelectedClass("");
      setSscSelectedSection("");
    }}
    label="Select Bus"
    renderValue={(selected) => selected?.busNumberPlate || ""}
  >
    {busData.map((bus, index) => (
      <MenuItem key={index} value={bus}>
        {bus.busNumberPlate}
      </MenuItem>
    ))}
  </Select>
</FormControl>


    {board === "SSC" && (
      <>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="class-select-label">Select Class</InputLabel>
          <Select
            labelId="class-select-label"
            value={sscSelectedClass}
            onChange={(e) => {
              const selected = e.target.value;
              setSscSelectedClass(selected);
              setMode("classSection");
              setSelectedBus("");

              const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
              setSscSectionOptions(sections);
              setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
            }}
            label="Select Class"
            sx={{ height: 35 }}
          >
            {sscClassOptions.map((cls) => (
              <MenuItem key={cls} value={cls}>
                {cls}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="section-select-label">Select Section</InputLabel>
          <Select
            labelId="section-select-label"
            value={sscSelectedSection}
            onChange={(e) => {
              setSscSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {sscSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Class
              </MenuItem>
            ) : (
              sscSectionOptions.map((section) => (
                <MenuItem key={section} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}

    {board === "INTERMEDIATE" && (
      <>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
          <Select
            labelId="intermediate-class-select-label"
            value={interSelectedClass}
            onChange={(e) => setInterSelectedClass(e.target.value)}
            label="Select Year"
            sx={{ height: 35 }}
          >
            <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
            <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="course-type-label">Select Course</InputLabel>
          <Select
            labelId="course-type-label"
            value={selectedCourseType}
            onChange={(e) => {
              setSelectedCourseType(e.target.value);
              setMode("classSection");
            }}
            label="Select Course"
            sx={{ height: 35 }}
          >
            {courseOptions.map((course, index) => (
              <MenuItem key={index} value={course}>
                {course}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
          <Select
            labelId="intermediate-section-select-label"
            value={interSelectedSection || ""}
            onChange={(e) => {
              setInterSelectedSection(e.target.value);
              setMode("classSection");
            }}
            label="Select Section"
            sx={{ height: 35 }}
          >
            {interSectionOptions.length === 0 ? (
              <MenuItem value="" disabled>
                Select Year and Course
              </MenuItem>
            ) : (
              interSectionOptions.map((section, index) => (
                <MenuItem key={index} value={section}>
                  {section}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </>
    )}
  </Grid>

  {/* Export Button Section */}
  <Grid item>
    <Button
      variant="contained"
      onClick={handleExportClick}
      style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
      startIcon={<PresentToAllIcon />}
    >
      Export
    </Button>

    <Menu
      anchorEl={exportAnchorEl}
      open={isExportMenuOpen}
      onClose={handleExportClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        },
      }}
    >
      <MenuItem
        onClick={exportToExcel}
        sx={{
          color: "#3f51b5",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#e8f0fe",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#00796b" }}>
          <SimCardDownloadIcon />
        </ListItemIcon>
        <ListItemText primary="Excel" sx={{ fontWeight: "bold", color: "#00796b" }} />
      </MenuItem>

      <MenuItem
        onClick={exportToPDF}
        sx={{
          color: "#d32f2f",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "#fdecea",
          },
        }}
      >
        <ListItemIcon sx={{ color: "#d32f2f" }}>
          <PictureAsPdfIcon />
        </ListItemIcon>
        <ListItemText primary="PDF" sx={{ fontWeight: "bold", color: "#d32f2f" }} />
      </MenuItem>
    </Menu>
  </Grid>
</Grid>



<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>S.No</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Student Id</TableCell> */}
                                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Name</TableCell>
                {(board === "INTERMEDIATE" ) && (
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Course</TableCell>
              )}
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>{board === "INTERMEDIATE" ? "Year" : "Class"}</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Section</TableCell>
              
                  
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Pass Photo</TableCell> */}

                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Gender</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Bus No</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Pickup Location</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Drop Location</TableCell>
                <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4",fontWeight:'bold',fontSize:'14px' }}>Phone</TableCell>
                {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "2px", textAlign: "center", backgroundColor: "#fff9c4" }}>Status</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableLoading ? (
                <TableRow>
                                  <TableCell colSpan={15} style={{ textAlign: "center", padding: "20px" }}>
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                    <CircularProgress />
                                                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                                                      Loading Data...
                                                                    </Typography>
                                                                  </Box>
                                                                </TableCell>
                                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow key={row.id} style={{
                    backgroundColor: "white",
                    transition: "background-color 0.3s",
                    height: "40px",  // Reduced row height
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white"; // Default color
                  }}>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>
                    {/* <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentId}</TableCell> */}
                     <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentFirstName} {row.studentLastName}</TableCell>
                    {board === "INTERMEDIATE" && (
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.course}</TableCell>
                  )}
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.romanNumberClass}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.sections}</TableCell>
                    

                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.gender || "N/A"}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumberPlate}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentPickupLocation}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentDropLocation}</TableCell>
                    <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.fatherPhoneNumber}</TableCell>
                   
                   
                   
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog for editing */}
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
          <DialogTitle>Edit Details</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Name"
                  value={selectedRow ? selectedRow.name : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      name: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Gender"
                  value={selectedRow ? selectedRow.gender : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      gender: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Bus No"
                  value={selectedRow ? selectedRow.busNumber : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      busNumber: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Route"
                  value={selectedRow ? selectedRow.route : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      route: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Pickup"
                  value={selectedRow ? selectedRow.pickup : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      pickup: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Drop"
                  value={selectedRow ? selectedRow.drop : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      drop: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Phone"
                  value={selectedRow ? selectedRow.phone : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      phone: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Amount"
                  value={selectedRow ? selectedRow.amount : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      amount: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSaveChanges} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );
}

export default PresentBusAttendeesList;